import React from 'react';

function CloseIcon({ stroke = '#1D1C1D', width = 16, height = 16, ...rest }) {
  return (
    <svg width={width} height={height} {...rest} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 14L14 6M6 6L14 14" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default CloseIcon;
